import state from './developererrorlog.state'
import mutations from './developererrorlog.mutations'
import actions from './developererrorlog.actions'

export default {
  state,
  mutations,
  actions
}
